import './App.css';
import Footer from './Footer';
import Dictionary from './Dictionary';


export default function App() {
  return (
    <div className="App">
      <Dictionary />
      <Footer />
    </div>
  );
}


